<template>
  <div>
    <!-- 定制化行业解决方案 -->
    <div class="programme-index" id="solution">
      <div class="title">{{ title }}</div>
      <div class="tab-boxs wow fadeInUp" data-wow-delay="100ms">
        <div class="btn-wrap">
          <div v-for="(item, index) in btnList" :key="index" @click="selectBar(index)" :class="['btn', actIndex === index ? 'active' : '']">
            <img class="img" :src="item.imgSrc" />
            <p class="name">{{ item.name }}</p>
          </div>
        </div>
        <div class="prog_list wow fadeIn" data-wow-delay="150ms">
          <div v-show="actIndex == index" v-for="(item, index) in solutionList" :key="index" class="item">
            <img class="img" :src="item.imgSrc" />
            <div class="right">
              <h6 class="name">{{ item.title }}</h6>
              <p class="content">{{ item.des }}</p>
              <a :href="item.href" class="get-info" target="_blank">了解详情</a>
              <div class="name demo">客户案例</div>
              <div class="demo-list">
                <div class="demo-item" v-for="(subitem, subindex) in item.orgImg" :key="subindex">
                  <img class="s-box" :src="subitem" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- h5版本 -->
    <div class="programme-index-mobile" id="solution">
      <div class="title">{{ title }}</div>
      <div class="btn-info" data-wow-delay="100ms">
        <div class="btn-con">
          <div v-for="(item, index) in btnList" @click="selectBar(index)" :class="['item', actIndex == index ? 'active' : '']" :key="index">
            <div class="text">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in solutionList"
        :key="index"
        :class="['solution-item', 'fadeIn', actIndex == index ? 'solution-item-active' : '']"
      >
        <div class="img-wrap">
          <img class="img" :src="item.mobileImgSrc" />
        </div>
        <div class="name">{{ item.title }}</div>
        <div class="content">{{ item.des }}</div>
        <a :href="item.href" class="get-info" target="_blank">了解详情</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    solutionList: Array,
    btnList: Array,
  },
  data() {
    return {
      actIndex: 0,
    }
  },
  mounted() {
    const that = this
    // console.info(swiper)
  },
  methods: {
    // 选中tab
    selectBar(index) {
      if (this.actIndex !== index) {
        this.actIndex = index
        console.log('this.mySwiper', this.mySwiper)
        // this.mySwiper.slideTo(index, 1000, false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .programme-index-mobile {
    display: none;
  }
  .programme-index {
    width: 100%;
    background-color: #fff;
    padding-top: 70px;
    padding-bottom: 82px;
    .title {
      width: 100%;
      background-color: #fff;
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 56px;
      text-align: center;
    }
    .tab-boxs {
      width: 100%;
      max-width: 1400px;
      background-color: #fff;
      padding-top: 70px;
      margin: 0 auto;
      .btn-wrap {
        max-width: 1400px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 175px;
        .btn {
          display: flex;
          align-items: center;
          flex-direction: column;
          min-width: 20%;
          padding-bottom: 30px;
          .img {
            width: 70px;
            height: 70px;
          }
          .name {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #202640;
            line-height: 22px;
            margin-top: 3px;
          }
          &:hover {
            .name {
              color: #e61717;
            }
          }
        }
        .active {
          position: relative;
          &::after {
            position: absolute;
            content: '';
            width: 100%;
            height: 4px;
            background: #e61717;
            bottom: -2px;
            left: 50%;
            margin-left: -50%;
          }
        }
      }
    }
    .prog_list {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 20px;
      .item {
        display: flex;
        align-items: center;
        border: 1px solid #eeeeee;
        .img {
          display: inline-block;
          width: 40%;
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 40px;
          padding: 16px 0px;
          .name {
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #202640;
            line-height: 28px;
            margin-bottom: 21px;
          }
          .content {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #202640;
            line-height: 26px;
            margin-bottom: 18px;
          }
          .get-info {
            width: 90px;
            font-size: 16px;
            color: #e61717;
            padding-right: 22px;
            background: url('../../../../assets/images/get-info-jiantou.png') no-repeat right center;
            background-size: 17px auto;
            line-height: 22px;
            margin-bottom: 86px;
          }
          .get-info:hover {
            opacity: 0.7;
          }
          .demo-list {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .demo-item {
              width: 22%;
              margin-right: 18px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .programme-index {
    display: none;
  }
  .programme-index-mobile {
    background-color: #fff;
    padding-top: 1.0667rem;
    padding-bottom: 1.0667rem;
    .title {
      font-size: 0.5867rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 0.5867rem;
      text-align: center;
    }
    .btn-info {
      margin-top: 1.0667rem;
      padding-left: 0.4rem;
      border-bottom: 1px solid #eeeeee;
      width: 100%;
      overflow: auto;
      white-space: nowrap;
      .btn-con {
        width: auto;
      }
      .item {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.48rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202640;
        line-height: 0.6667rem;
        margin-right: 0.8rem;
        padding-bottom: 0.2667rem;
      }
      .active {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: 1.7067rem;
          height: 0.08rem;
          background: #e61717;
          left: 0;
          bottom: 0;
        }
      }
    }
    .solution-item {
      display: none;
      .img-wrap {
        padding: 0.64rem 0.4rem;
        background-color: #fafafc;
        .img {
          width: 100%;
          height: 4.88rem;
        }
      }
      .name {
        font-size: 0.48rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #202640;
        line-height: 0.6667rem;
        margin-top: 0.8rem;
        padding: 0 0.4rem;
      }
      .content {
        margin-top: 0.2667rem;
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202640;
        line-height: 0.64rem;
        padding: 0 0.4rem;
      }
      .get-info {
        display: inline-block;
        margin-top: 0.5333rem;
        width: 2.4rem;
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e61717;
        line-height: 0.5333rem;
        padding-right: 0.5867rem;
        background: url('../../../../assets/images/get-info-jiantou.png') no-repeat right center;
        background-size: auto;
        padding: 0 0.4rem;
      }
    }
    .solution-item-active {
      display: block;
    }
  }
}
</style>
